import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons"

export const Whatsapp = (props) => {
  return <FontAwesomeIcon faIcon={faWhatsapp} {...props} />
}
